import { useTranslation } from 'react-i18next'

import B2BecLink from '@/components/B2BLink'
import Footer from '@/components/Layout/Footer'
import Header from '@/components/PublicHeader/Header'
import { useDocumentTitle } from '@/hooks'
import useAdobeAnalysis from '@/hooks/useAdobeAnalysis'
import { PAGE_TYPES } from '@/libs/constants/adobeAnalytics'

import styles from './PublicPageNotFound.module.scss'

interface PublicPageNotFoundProps {
  title?: string
  pageId?: string
}

const PublicPageNotFound = ({
  title = '404 Not found',
  pageId = '404',
}: PublicPageNotFoundProps) => {
  useDocumentTitle(title)
  const { t } = useTranslation()

  useAdobeAnalysis(null, {
    pageId,
    pageName: '404 not found page',
    pageType: PAGE_TYPES.ERROR,
  })

  return (
    <>
      <Header />
      <div className={styles.wrapper}>
        <h1 className="text-3xl mb-4">{t('errors.pageNotFound')}</h1>
        <p className="text-sm font-normal mb-3">
          {t('errors.pageNotFoundMessage')}
        </p>
        <p className="text-sm font-normal">
          <B2BecLink to="">{t('errors.backHomeButton')}</B2BecLink>
        </p>
      </div>
      <Footer />
    </>
  )
}

export default PublicPageNotFound
